import * as React from "react";
import { Grid, TextField } from "@mui/material";

export default function ManagerForm({ handleChange, newManager, errors }) {
  return (
    <Grid container spacing={2}>
      <Grid item xs={12} sm={6}>
        <TextField
          autoFocus
          margin="dense"
          name="first_name"
          label="First Name"
          type="text"
          fullWidth
          variant="outlined"
          value={newManager.first_name}
          onChange={handleChange}
          error={Boolean(errors.first_name)}
          helperText={errors.first_name}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <TextField
          margin="dense"
          name="last_name"
          label="Last Name"
          type="text"
          fullWidth
          variant="outlined"
          value={newManager.last_name}
          onChange={handleChange}
          error={Boolean(errors.last_name)}
          helperText={errors.last_name}
        />
      </Grid>

      <Grid item xs={12} sm={6}>
        <TextField
          margin="dense"
          name="phone_number"
          label="Phone Number"
          type="text"
          fullWidth
          variant="outlined"
          value={newManager.phone_number}
          onChange={handleChange}
          error={Boolean(errors.phone_number)}
          helperText={errors.phone_number}
        />
      </Grid>

      <Grid item xs={12} sm={6}>
        <TextField
          margin="dense"
          name="email"
          label="Email"
          type="email"
          fullWidth
          variant="outlined"
          value={newManager.email}
          onChange={handleChange}
          error={Boolean(errors.email)}
          helperText={errors.email}
        />
      </Grid>

      <Grid item xs={12} sm={6}>
        <TextField
          margin="dense"
          name="username"
          label="Username"
          type="text"
          fullWidth
          variant="outlined"
          value={newManager.username}
          onChange={handleChange}
          error={Boolean(errors.username)}
          helperText={errors.username}
        />
      </Grid>

      <Grid item xs={12} sm={6}>
        <TextField
          margin="dense"
          name="password"
          label="Password"
          type="password"
          fullWidth
          variant="outlined"
          value={newManager.password}
          onChange={handleChange}
          error={Boolean(errors.password)}
          helperText={errors.password}
        />
      </Grid>
    </Grid>
  );
}
